<div class="card-header bg-success">
    <div class="row">
        <div class="col-md-6">
            <h3 class="text-white">Quote: {{(quoteDetails)?quoteDetails.reference:''}}
                <span class="badge badge-danger text-white text-capitalize">{{(quoteDetails)?quoteDetails.status:''}}</span>
            </h3>
        </div>
        <div class="col-md-6 text-right" *ngIf="quoteDetails">
            <span *ngIf="!isBroker">
                <button (click)="markAsReferred(referQuoteModal)" class="btn btn-dark btn-sm mr-2">Manual Refer</button>
            </span>
            <span *ngIf="quoteDetails.status != 'referred' && quoteDetails.status != 'issued' && quoteDetails.status != 'declined'">
                <a [routerLink]="['/agrimotor/quote', id]" class="btn btn-danger btn-sm">Edit</a>
            </span>
            <span *ngIf="quoteDetails.status == 'quote' || quoteDetails.status == 'referral approved' || quoteDetails.status == 'renewal invited'">
                <button (click)="issueQuotePopup(issueQuoteModal)" class="btn btn-dark btn-sm ml-2">Issue Quote</button>
            </span>
        </div>
    </div>
</div>
<mat-tab-group class="float-left w-100" [(selectedIndex)]="selectedIndex">
    <mat-tab>
        <ng-template mat-tab-label>Overview</ng-template>
        <div class="card-body"><app-ag-overview [quoteDetails]="quoteDetails"></app-ag-overview></div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>Full Details</ng-template>
        <div class="card-body"><app-ag-full-details [quoteDetails]="quoteDetails"></app-ag-full-details></div>
    </mat-tab>
    <mat-tab *ngIf="quoteDetails && quoteDetails.fleet_experiences && quoteDetails.fleet_experiences.length > 0">
        <ng-template mat-tab-label>Fleet Experiences</ng-template>
        <div class="card-body"><app-ag-fleet-experiences-view [quoteDetails]="quoteDetails"></app-ag-fleet-experiences-view></div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>Drivers</ng-template>
        <div class="card-body"><app-ag-drivers-view [quoteDetails]="quoteDetails"></app-ag-drivers-view></div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>Financials</ng-template>
        <div class="card-body"><app-ag-financials [quoteDetails]="quoteDetails"></app-ag-financials></div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>Documents</ng-template>
        <div class="card-body"><app-ag-documents [quote]="quoteDetails"></app-ag-documents></div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>Notes <span *ngIf="hasImportantNotes" class="ml-1" style="color: #ff0000" title="{{totalImpNotes}} Important Notes"><i class="mdi mdi-alert-circle"></i></span></ng-template>
        <div class="card-body"><app-quote-notes [quote]="quoteDetails" (hasImportantNotes)="onhasImportantNotesChange($event)"></app-quote-notes></div>
    </mat-tab>
    <mat-tab *ngIf="isAdmin">
        <ng-template mat-tab-label>Email</ng-template>
        <div class="card-body">
            <app-quote-email (emailView)="getEmailView($event)" (newEmailView)="newEmailView()" [quote]="quoteDetails" *ngIf="!displayEmailView && !displayNewEmailView"></app-quote-email>
            <app-quote-email-view (backToEmailsList)="backToEmailsList()" [email_id]="email_id" *ngIf="displayEmailView"></app-quote-email-view>
            <app-quote-email-compose (backToEmailsList)="backToEmailsList()" [quote]="quoteDetails" *ngIf="displayNewEmailView"></app-quote-email-compose>
        </div>
    </mat-tab>
</mat-tab-group>
<ng-template #issueQuoteModal let-modal>
    <div class="modal-body"><p>Do you want to issue the quote?</p></div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-sm" (click)="modal.close()">No</button>
        <button type="button" class="btn btn-success btn-sm" (click)="issueQuote()">Yes</button>
    </div>
</ng-template>
<ng-template #referQuoteModal let-modal>
    <div class="modal-body">
        <div class="mb-3">
            <label>Refer Reason</label>
            <textarea name="refer_reason" class="form-control" [(ngModel)]="refer_reason" (change)="onReferReasonChange($event)"></textarea>
            <div class="text-danger" *ngIf="(refer_reason_error)">Please enter some notes.</div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-sm" (click)="modal.close()">No</button>
        <button type="button" class="btn btn-success btn-sm" (click)="referQuote()">Yes</button>
    </div>
</ng-template>
